// extracted by mini-css-extract-plugin
export default {"container":"UploadFAQ_container__YNWo0","uploadFAQ":"UploadFAQ_uploadFAQ__753bb"};